import { css } from '@emotion/react'
import { Cell, FormControl, Grid, Theme, useTheme, VFlow } from 'bold-ui'
import { CnsField, DateField, TextField } from 'components/form'

import { CitopatologicoPerguntaField } from './model-citopatologico'

export function CitopatologicoDadosColetaModalStep() {
  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <VFlow>
      <Grid>
        <Cell>
          <DateField name={CitopatologicoPerguntaField.dataDaColeta} label='Data da coleta' required />
        </Cell>
        <Cell size={10}>
          <VFlow style={styles.container}>
            <FormControl label='Responsável pela coleta' style={styles.title} required />
            <TextField name={CitopatologicoPerguntaField.nomeResponsavel} label='Nome' required />
            <CnsField name={CitopatologicoPerguntaField.cns} label='CNS' required clearable />
          </VFlow>
        </Cell>
        <Cell size={10}>
          <VFlow style={styles.container}>
            <FormControl label='Conselho' style={styles.title} required />
            <TextField name={CitopatologicoPerguntaField.siglaNomeConselho} label='Nome' required clearable />
            <TextField name={CitopatologicoPerguntaField.numeroConselho} label='Número' required clearable />
          </VFlow>
        </Cell>
      </Grid>
    </VFlow>
  )
}

const createStyles = (theme: Theme) => ({
  container: css`
    position: relative;
    margin-top: 1rem;
    padding: 1rem;
    border: 1px solid ${theme.pallete.gray.c80};
  `,
  title: css`
    font-weight: bold;
    position: absolute;
    top: -0.75rem;
    margin-left: -0.75rem;
    padding: 0 0.5rem;
    background-color: ${theme.pallete.surface.main};
  `,
})
